export default __webpack_public_path__ + "static/media/080_finish_good.b8e4b4c2.mp4";